import {
  Box,
  Paper,
  Typography,
} from "@material-ui/core";
import KVMViewer from "modus/components/misc/KVMViewer";

import React from "react";
import GenericPageTitle from "modus/components/generic-page-title/GenericPageTitle";
import SpikeArrestConfigForm from "./SpikeArrestConfigForm";
import SubscriptionQuota from "./SubscriptionQuotaForm";
import type { IDeploymentApiThrottling } from "../services/ApiService";

function throttleUnitLabel(unit: string | undefined): string {
  if (unit == null || unit === "") {
    return "";
  }
  return String(unit).toLowerCase();
}

function quotaConfigFromApi(t: IDeploymentApiThrottling) {
  return {
    enabled: t.subscriptionQuotaEnabled ?? false,
    limit: t.subscriptionQuotaLimit ?? 0,
    interval: t.subscriptionQuotaInterval ?? 0,
    unit: t.subscriptionQuotaTimeunit ?? "MINUTE",
  };
}

function spikeConfigFromApi(t: IDeploymentApiThrottling) {
  return {
    enabled: t.spikeArrestEnabled ?? false,
    limit: t.spikeArrestLimit ?? 0,
    unit: t.spikeArrestTimeunit ?? "SECOND",
  };
}

interface ThrottlingDetailsProps {
  deploymentId: string;
  deployStatus?: string;
  refreshDeploymentList: () => void;
  apiThrottling?: IDeploymentApiThrottling | null;
  serviceId: string;
}


  export type TimeUnit = {
    key: string;
    value: string;
  };

  const availableSpikeArrestTimeUnit: readonly TimeUnit[] = [
    { key: "per Second", value: "SECOND" },
    { key: "per Minute", value: "MINUTE" },
  ] as const;

  const availableQuotaArrestTimeUnit: readonly TimeUnit[] = [
    { key: "per Hour", value: "HOUR" },
    { key: "per Day", value: "DAY" },
    { key: "per Week", value: "WEEK" },
    { key: "per Month", value: "MONTH" },
    { key: "per Minute", value: "MINUTE" },
  ] as const;


export const ThrottlingDetails: React.FC<ThrottlingDetailsProps> = React.memo((props) => {




  return (
    <Paper style={{ width: "100%" }}>
      <Box padding={"20px"}>
        <GenericPageTitle
          noSkeleton
          title={
            <Typography variant="body1" style={{ fontWeight: 600 }}>
              Throttling Features
            </Typography>
          }
        ></GenericPageTitle>
        <KVMViewer
          dataList={{
            "Spike Arrest": (
              <Box
                display={"flex"}
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>{props?.apiThrottling!=null && props?.apiThrottling?.spikeArrestLimit!==0 ? `${props?.apiThrottling?.spikeArrestLimit} hits / ${throttleUnitLabel(props?.apiThrottling?.spikeArrestTimeunit)}`: "No Limit"}</Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <SpikeArrestConfigForm
                    SubscriptionQuotaConfig={
                      props?.apiThrottling
                        ? quotaConfigFromApi(props.apiThrottling)
                        : null
                    }
                    spikeArrestConfig={
                      props?.apiThrottling
                        ? spikeConfigFromApi(props.apiThrottling)
                        : null
                    }
                    deploymentStatus={props?.deployStatus || null}
                    onSuccess={props?.refreshDeploymentList}
                    deploymentId={props?.deploymentId}
                    availableTimeUnit={availableSpikeArrestTimeUnit}
                    spikeArrestEnabled={props?.apiThrottling?.spikeArrestEnabled ?? false }
                    serviceId={props?.serviceId}
                  ></SpikeArrestConfigForm>

                </Box>
              </Box>
            ),
            "Subscription Quota": (
              <Box
                display={"flex"}
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>{props?.apiThrottling!=null && props?.apiThrottling?.subscriptionQuotaLimit!==0 ? `${props?.apiThrottling?.subscriptionQuotaLimit} hits per ${props?.apiThrottling?.subscriptionQuotaInterval} ${throttleUnitLabel(props?.apiThrottling?.subscriptionQuotaTimeunit)}` : "No Limit"}</Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                >
                  <SubscriptionQuota
                    SubscriptionQuotaConfig={
                      props?.apiThrottling
                        ? quotaConfigFromApi(props.apiThrottling)
                        : null
                    }
                    spikeArrestConfig={
                      props?.apiThrottling
                        ? spikeConfigFromApi(props.apiThrottling)
                        : null
                    }
                    deploymentStatus={props?.deployStatus || null}
                    serviceId={props?.serviceId}
                    subscriptionQuotaEabled={props?.apiThrottling?.subscriptionQuotaEnabled ?? false }
                    onSuccess={props?.refreshDeploymentList}
                    availableTimeUnit={availableQuotaArrestTimeUnit}
                    deploymentId={props.deploymentId}
                  ></SubscriptionQuota>

                </Box>
              </Box>
            ),
          }}
        />
      </Box>
    </Paper>
  );
});